import { checkWord } from "../../wordfill";
import { TestableWord } from "../../wordfill/types";
import { Answer, Content, Score, TestedDefinition, Word } from "../types";

export function markAnswer(content: Content, answer: Answer): Score {
  let score = 0;
  let total = 0;

  const definitionScores = content.definitions.reduce(
    (definitions: any, definition: TestedDefinition) => {
      if (definition && definition.testing) {
        total++;

        const { word, otherPermittedWords } = getWordFromTestableWordArray(
          definition.word
        );
        //preset it to false
        definitions[word] = false;

        if (!answer || !answer.definitions || !answer.definitions[word]) {
          definitions[word] = false;
        } else {
          // If answer matches explicit definition mark correct
          if (checkWord(word, answer.definitions[word])) {
            definitions[word] = true;
          } else if (otherPermittedWords && otherPermittedWords.length > 0) {
            // Else check loop over other permitted definitions
            for (let i = 0; i <= otherPermittedWords.length - 1; i++) {
              if (checkWord(otherPermittedWords[i], answer.definitions[word])) {
                definitions[word] = true;
                break;
              }
            }
          } else {
            definitions[word] = false;
          }

          definitions[word] && score++;
        }
      }

      return definitions;
    },
    {}
  );
  return {
    definitions: definitionScores,
    score: score / total
  };
}

export function getWordFromTestableWordArray(testableWord: Word): TestableWord {
  if (!testableWord || typeof testableWord === "string") {
    return {
      word: testableWord!,
      otherPermittedWords: []
    };
  }

  let wordObjectReturn;
  testableWord.forEach(word => {
    if (typeof word !== "string") {
      wordObjectReturn = {
        word: word.caps || word.word,
        otherPermittedWords: word.otherPermittedWords
      };
    }
  });
  return wordObjectReturn as any;
}

export const generateInitialUserAnswer = () => ({
  definitions: {}
});
